module.exports = __webpack_public_path__ + "static/img/69.154de8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/69.png
// module id = NDCR
// module chunks = 0